module.exports = __webpack_public_path__ + "static/media/slider-1.968a02d2.png";